module.exports = __webpack_public_path__ + "img/UNOPEN.3898c6d0.png";